import { Component, DOCUMENT, inject, Inject, Input } from '@angular/core';
import { Button } from '../button/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-empty-data',
  imports: [Button],
  templateUrl: './empty-data.html',
  styleUrl: './empty-data.css',
})
export class EmptyData {
  @Input() message!: string;
  private readonly router = inject(Router);

  constructor(@Inject(DOCUMENT) private document: Document) {}

  handleClick() {
    this.reload();
  }

  reload() {
    this.router.navigateByUrl(this.router.url);
  }
}
